import { render, staticRenderFns } from "./healthVisitRecordForm.vue?vue&type=template&id=89debe1c&scoped=true&"
import script from "./healthVisitRecordForm.vue?vue&type=script&lang=js&"
export * from "./healthVisitRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./healthVisitRecordForm.vue?vue&type=style&index=0&id=89debe1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89debe1c",
  null
  
)

export default component.exports